module.exports = __webpack_public_path__ + "media/images/map/marker-699a2f33b7a4307c1d2305333d255292.png";